export enum FEATURE_NAME {
  TRANSACTIONS = 'TRANSACTIONS',
  API = 'API',
  MSZAFIR = 'MSZAFIR',
  SIGNIUS = 'SIGNIUS',
  EXTERNAL_SIGNATURE = 'EXTERNAL_SIGNATURE',
  ZEALID_SIGNATURE = 'ZEALID_SIGNATURE',
  SIGNATURE_POSITION_CUSTOMIZATION = 'SIGNATURE_POSITION_CUSTOMIZATION',
  EMAIL_CUSTOMIZATION = 'EMAIL_CUSTOMIZATION',
  DOCUMENT_BRANDING = 'DOCUMENT_BRANDING',
  QUEUE_GROUPS = 'QUEUE_GROUPS',
  IDENTITY_CONFIRMATION_PWPW = 'IDENTITY_CONFIRMATION_PWPW',
  WEBHOOKS = 'WEBHOOKS',
  TEMPLATE_CREATOR_V2 = 'TEMPLATE_CREATOR_V2',
  PDF_RENDERER_V2 = 'PDF_RENDERER_V2',
  QR_CODE = 'QR_CODE',
  CONTACTS_V2 = 'CONTACTS_V2',
  DOCUMENTS_V2 = 'DOCUMENTS_V2',
  PUBLIC_TEMPLATES = 'PUBLIC_TEMPLATES',
  DATA_SOURCES = 'DATA_SOURCES',
  AUTO_REMINDERS = 'AUTO_REMINDERS',
}

export type FeatureItemType = {
  feature: FEATURE_NAME;
  enabled: boolean;
};

export type GetFeaturesResponseType = {
  data: FeatureItemType[];
};
